<app-loading-spinner *ngIf="installing"></app-loading-spinner>

<h1 *ngIf="installFailed">
  {{'SHOPRENTER_ERROR_SHOP_INSTALL_FAILED' | translate}}
</h1>

<h1 *ngIf="invalidArguments">
  {{'SHOPRENTER_ERROR_INVALID_ARGUMENTS' | translate}}
</h1>
